import React from 'react';
import PropTypes from 'prop-types';
import ReduxFormImageUpload from 'modules/styled/form/reduxformimageupload.component';
import {
  FormImage,
  CTALink,
  View,
  Row,
  Button as UniButton,
  InlineLink,
} from 'modules/styled';
import ReduxFormField from 'modules/styled/form/reduxformfield.component';
import { Field, reduxForm } from 'redux-form';
import { required } from 'modules/form/validators';
import { withRouter } from 'react-router-dom';
import { Button, Form } from 'modules/styled/web';

SettingsModal.propTypes = {
  close: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
};

function SettingsModal({ handleSubmit, location, close }) {
  const FORM_FIELDS = [
    {
      name: 'image',
      component: ReduxFormImageUpload,
      placeholder: '/img/blueR.png',
      imageComponent: <FormImage />,
      type: 'file-upload',
      label: 'User Image',
      validate: [],
    },
    {
      name: 'name',
      component: ReduxFormField,
      type: 'text',
      label: 'Display Name',
      validate: [required],
    },
    {
      name: 'bio',
      component: ReduxFormField,
      type: 'text',
      label: 'Bio',
    },
  ];
  return (
    <View>
      <Form onSubmit={handleSubmit}>
        {FORM_FIELDS.map((field, index) => (
          <Field {...field} key={index} />
        ))}
        <InlineLink sx={{ mt: 1 }} to={`/user/resetPassword${location.search}`}>
          <CTALink>Reset Password</CTALink>
        </InlineLink>
        <Row sx={{ justifyContent: 'flex-end', mt: 3 }}>
          <UniButton
            type="button"
            sx={{ bg: 'white', mr: 2 }}
            textSx={{ color: 'black' }}
            onPress={() => close && close()}
          >
            Cancel
          </UniButton>
          <Button type="submit">Submit</Button>
        </Row>
      </Form>
    </View>
  );
}

export default withRouter(
  reduxForm({
    form: 'settings',
  })(SettingsModal)
);
